import "./styles.css";
import { Header } from "../header-new/header";
import equi from "../../asset-source/chin-chin-wjet-header-1.png";
import equi2 from "../../asset-source/chin-chin-wjet-main-screens-3-2.png";
import chinchinpic from "../../asset-source/chin-chin-wjet-meeting-4.png";
import chinchinpic1 from "../../asset-source/chin-chin-wjet-meeting-chat-5-1.png";
import mapped from "../../asset-source/chin-chin-wjet-meeting-search-5-2.png";
import rating from "../../asset-source/chin-chin-wjet-participants-rating-6.png";
import system from "../../asset-source/chin-chin-wjet-design-system-7.png";
import screenshot from "../../asset-source/chin-chin-wjet-app-screenshots-8.png";

import { useState } from "react";
import check from "../../asset-source/chk.svg";
import { Footer } from "../footer/footer";

import pic1 from "../../asset-source/chin-chin-wjet-onboarding-3-1.png";

import ContactUsModal from "../modal/contact-us";
import { useNavigate } from "react-router-dom";

function ChinChinPage() {
	const navigate = useNavigate();

	document.title =
		"GoChinChin — UX|UI дизайн приложения для знакомств и нетворкинга";
	document.getElementsByTagName("META")[2].content =
		"GoChinChin — приложение для знакомств и нетворкинга. Интуитивный UX/UI дизайн, продуманный пользовательский путь и удобный интерфейс для общения";

	document.getElementsByTagName("META")[3].content =
		"UX/UI дизайн, разработка интерфейса приложения, разработка UX/UI дизайна, кейс UX/UI дизайн, проектирование цифровых продуктов, разработка пользовательских сценариев, UX исследования, дизайн для мобильных приложений, UX/UI для приложений знакомств";

	return (
		<div className="chinchin">
			<div className="wrapper gradiented">
				<Header onLight={true} />

				<div className="container">
					<a href="/" className="allProjectLink">
						<svg
							width="17"
							height="16"
							viewBox="0 0 17 16"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								id="Arrow 4"
								d="M0.292892 8.70711C-0.0976315 8.31658 -0.0976315 7.68342 0.292892 7.29289L6.65685 0.928932C7.04738 0.538408 7.68054 0.538408 8.07107 0.928932C8.46159 1.31946 8.46159 1.95262 8.07107 2.34315L2.41421 8L8.07107 13.6569C8.46159 14.0474 8.46159 14.6805 8.07107 15.0711C7.68054 15.4616 7.04738 15.4616 6.65685 15.0711L0.292892 8.70711ZM17 9H1V7H17V9Z"
								fill="currentColor"
							/>
						</svg>
						Все проекты
					</a>

					<div className="titleBlock">
						<img
							src={equi}
							alt="Главный экран приложения GoChinChin с темным фоном и яркими акцентами"
							className="picture"
						/>
					</div>
				</div>
			</div>

			<div className="feature__wrapper">
				<div className="container">
					<div className="containersm">
						<div className="about__title">
							<h1 className="about__titlerow">
								GoChinChin&nbsp;— UX/UI дизайн для&nbsp;приложения,
								где&nbsp;легко найти «своих»
							</h1>
						</div>

						<div className="about__features">
							<div className="about__featureunit">
								<div>Бренд</div>
								<div className="about__featurevalue">GoChinChin</div>
							</div>

							<div className="about__featureunit">
								<div>Индустрия</div>
								<div className="about__featurevalue">
									Dating & Networking (Знакомства и&nbsp;нетворкинг), Lifestyle
									(Образ жизни)
								</div>
							</div>

							<div className="about__featureunit">
								<div>Релиз</div>
								<div className="about__featurevalue">2024</div>
							</div>

							<div className="about__featureunit">
								<div>Cсылка</div>
								<a
									href="https://gochinchin.com"
									target="_blank"
									className="about__featurevalue"
									rel="noreferrer"
								>
									gochinchin.com
								</a>
							</div>
						</div>

						<div className="abouts">
							<div className="aboutstitle">О&nbsp;проекте</div>
							<div className="about__hatinfo">
								Найти друзей, завести новые знакомства в&nbsp;любой точке мира,
								а&nbsp;может просто приятно провести вечер с&nbsp;хорошими
								людьми за&nbsp;бокалом просекко? С&nbsp;новым приложением
								GoChinChin нет&nbsp;ничего проще. Мы&nbsp;продумали UX дизайн
								и&nbsp;сделали приложение современным и&nbsp;стильным,
								а&nbsp;также проработали пользовательские сценарии,
								чтобы&nbsp;любой пользователь мог&nbsp;как&nbsp;создавать
								встречу, так&nbsp;и&nbsp;подавать заявку на&nbsp;встречи,
								созданные другими участниками.
							</div>
						</div>

						<div className="abouts">
							<div className="aboutstitle">Задача</div>
							<div className="about__hatinfo">
								<div className="numlist">
									<div className="numlistUnit">
										<div className="numlistDot" />
										<div>
											Сделать интуитивно понятное, простое в&nbsp;использовании
											приложение для&nbsp;общения, поиска новых знакомых
											с&nbsp;общими интересами, приятного времяпрепровождения
										</div>
									</div>

									<div className="numlistUnit">
										<div className="numlistDot" />
										<div>
											Отойти от&nbsp;стандартных концепций подобных приложений
											и&nbsp;сделать что‑то современное, динамичное, яркое,
											для&nbsp;активной аудитории
										</div>
									</div>

									<div className="numlistUnit">
										<div className="numlistDot" />
										<div>
											Совместить в&nbsp;приложении удобство пользователей
											и&nbsp;нестандартный дизайн
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className="abouts">
							<div className="aboutstitle">Решение</div>
							<div className="about__hatinfo">
								<div className="numlist">
									<div className="numlistUnit">
										<div className="numlistDot" />
										<div>
											Приложение с интуитивным интерфейсом и простой навигацией,
											созданное с учётом особенностей и интересов нескольких
											категорий пользователей
										</div>
									</div>

									<div className="numlistUnit">
										<div className="numlistDot" />
										<div>
											Современный и стильный дизайн приложения, который
											ассоциируется с ночной жизнью, развлечениями и уютной
											атмосферой — идеально подходит для молодой активной
											аудитории
										</div>
									</div>

									<div className="numlistUnit">
										<div className="numlistDot" />
										<div>
											Спроектированы и реализованы разные сценарии
											использования — для администратора встреч и участников
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="feature__wrapper equi__colored">
				<div className="container">
					<div className="containersm">
						<div className="about__title">
							<div>
								<h2 className="about__titlerow">
									Как&nbsp;исследования аудитории и&nbsp;JTBD определили UX/UI
									дизайн приложения
								</h2>

								<div className="about__hatinfo hatinfo__hatfix">
									Перед&nbsp;тем&nbsp;как&nbsp;начать проектировать
									и&nbsp;разрабатывать дизайн приложения, мы&nbsp;провели серию
									исследований. Это&nbsp;помогло нам&nbsp;точно определить
									целевую аудиторию, понять её&nbsp;потребности и&nbsp;ожидания.
								</div>
							</div>
						</div>

						<div className="abouts">
							<h3 className="aboutstitle">
								Jobs-to-be-done приложения,
								или&nbsp;для&nbsp;чего&nbsp;пользователи выбирают GoChinChin
							</h3>
							<div className="about__hatinfo">
								Приложение предназначено для&nbsp;того, чтобы&nbsp;объединять
								людей по&nbsp;интересам, географическому положению и&nbsp;другим
								важным критериям. С&nbsp;его&nbsp;помощью просто заводить новые
								знакомства, расширять круг общения через&nbsp;нетворкинг
								или&nbsp;просто проводить время в&nbsp;компании
								единомышленников. GoChinChin даёт пользователям возможность
								легко находить и&nbsp;организовывать мероприятия поблизости,
								которые совпадают с&nbsp;их&nbsp;интересами, будь
								то&nbsp;профессиональные встречи, хобби-клубы или&nbsp;дружеские
								посиделки.
							</div>
						</div>

						<div className="abouts">
							<h3 className="aboutstitle">
								Портрет пользователей GoChinChin: интересы и&nbsp;потребности
							</h3>
							<div className="about__hatinfo">
								Изначально приложение создавалось для&nbsp;рынка
								США&nbsp;и&nbsp;ориентировано на&nbsp;несколько категорий
								пользователей, с&nbsp;учётом их&nbsp;интересов
								и&nbsp;потребностей:
								<div className="numlist">
									<div className="numlistUnit">
										<div className="numlistNum">1.</div>
										<div>
											Любители мероприятий и&nbsp;активного досуга&nbsp;— те,
											кто&nbsp;ищет компанию для&nbsp;походов на&nbsp;концерты,
											спортивные события или&nbsp;другие мероприятия.
										</div>
									</div>

									<div className="numlistUnit">
										<div className="numlistNum">2.</div>
										<div>
											Люди с&nbsp;уникальными или&nbsp;узкими интересами&nbsp;—
											пользователи, которым сложно найти единомышленников
											в&nbsp;офлайн-среде.
										</div>
									</div>

									<div className="numlistUnit">
										<div className="numlistNum">3.</div>
										<div>
											Те, кто&nbsp;хочет расширить деловые связи, найти
											партнёров или&nbsp;коллег по&nbsp;интересам.
										</div>
									</div>

									<div className="numlistUnit">
										<div className="numlistNum">4.</div>
										<div>
											Интроверты и&nbsp;застенчивые люди&nbsp;— пользователи,
											которые испытывают сложности в&nbsp;инициировании
											знакомств и&nbsp;нуждаются в&nbsp;поддержке
											для&nbsp;комфортного общения.
										</div>
									</div>

									<div className="numlistUnit">
										<div className="numlistNum">5.</div>
										<div>
											Путешественники и&nbsp;иммигранты&nbsp;— люди, которые
											временно или&nbsp;постоянно находятся в&nbsp;новом городе
											или&nbsp;стране и&nbsp;хотят быстрее адаптироваться, найти
											компанию и&nbsp;изучить местную культуру.
										</div>
									</div>

									<div>
										Понимание потребностей каждой из&nbsp;этих групп позволило
										создать функционал и&nbsp;UX/UI дизайн, который помогает
										каждому сегменту легко находить нужные мероприятия
										и&nbsp;заводить знакомства.
									</div>
								</div>
							</div>
						</div>
					</div>

					<img
						src={pic1}
						alt="Интерфейс карты мероприятий в GoChinChin с отмеченными локациями"
						className="about__widepic"
					/>

					<div className="containersm">
						<div className="abouts">
							<h3 className="aboutstitle">
								А&nbsp;общий портрет целевой аудитории приложения выглядит так:
							</h3>
							<div className="about__hatinfo">
								<div className="numlist">
									<div className="numlistUnit">
										<div className="numlistNum">
											<img src={check} alt="" className="" />
										</div>
										<div>
											Возраст: мужчины и&nbsp;женщины
											от&nbsp;18&nbsp;до&nbsp;45&nbsp;лет
										</div>
									</div>

									<div className="numlistUnit">
										<div className="numlistNum">
											<img src={check} alt="" className="" />
										</div>
										<div>
											Характер: любознательность, открытость к&nbsp;новым
											знакомствам и&nbsp;опыту.
										</div>
									</div>

									<div className="numlistUnit">
										<div className="numlistNum">
											<img src={check} alt="" className="" />
										</div>
										<div>
											Мотивация: желание улучшить качество социальной жизни
											или&nbsp;расширить профессиональные возможности.
										</div>
									</div>

									<div className="numlistUnit">
										<div className="numlistNum">
											<img src={check} alt="" className="" />
										</div>
										<div>
											Технологическая грамотность: готовность использовать
											цифровые инструменты для&nbsp;решения повседневных задач.
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<img
						src={equi2}
						alt="Рейтинг участников встречи в приложении GoChinChin с системой звезд"
						className="about__widepic"
					/>
				</div>
			</div>

			<div className="feature__wrapper">
				<div className="container">
					<div className="containersm">
						<div className="about__title">
							<h2 className="about__titlerow">
								Современный дизайн GoChinChin: сочетание стиля, динамики
								и&nbsp;удобства
							</h2>
						</div>

						<div className="researchs">
							<h3 className="researchs__subtitle">Стиль и&nbsp;атмосфера</h3>
							<div>
								Мы&nbsp;создали современный и&nbsp;стильный вид&nbsp;приложения,
								который ассоциируется с&nbsp;ночной жизнью, развлечениями
								и&nbsp;уютной атмосферой. Тёмный фон&nbsp;и&nbsp;яркие
								акценты&nbsp;— кнопки и&nbsp;выделенные карточки&nbsp;— придают
								дизайну динамичность и&nbsp;соответствуют вкусам нашей целевой
								аудитории.
							</div>
						</div>

						<div className="researchs">
							<h3 className="researchs__subtitle">
								Визуальные акценты и&nbsp;фото
							</h3>
							<div>
								Чтобы&nbsp;создать дружелюбную атмосферу, мы&nbsp;использовали
								яркие фотографии. Благодаря им&nbsp;пользователи могут легко
								представить себя на&nbsp;встречах и&nbsp;мероприятиях,
								что&nbsp;вдохновляет их&nbsp;активнее пользоваться приложением.
							</div>
						</div>

						<div className="researchs">
							<h3 className="researchs__subtitle">
								Интуитивный интерфейс и&nbsp;навигация
							</h3>
							<div>
								Приложение получилось удобным и&nbsp;понятным с&nbsp;первого
								взгляда. Яркие кнопки и&nbsp;карточки делают навигацию простой
								и&nbsp;понятной. Пользователи быстро находят нужные разделы
								и&nbsp;функции, не&nbsp;теряясь в&nbsp;интерфейсе,
								что&nbsp;делает использование приложения удобным
								и&nbsp;приятным.
							</div>
						</div>

						<div className="researchs">
							<h3 className="researchs__subtitle">Удобное нижнее меню</h3>
							<div>
								Также&nbsp;мы&nbsp;добавили нижнее меню с&nbsp;постоянной
								навигацией на&nbsp;главные страницы. Оно&nbsp;всегда остаётся
								на&nbsp;экране. Пользователи могут в&nbsp;любой момент увидеть,
								есть&nbsp;ли&nbsp;непрочитанные уведомления, и&nbsp;быстро
								перейти к&nbsp;ним.
							</div>
						</div>

						<div className="researchs">
							<h3 className="researchs__subtitle">
								Визуальный стиль, подходящий для&nbsp;всех случаев
							</h3>
							<div>
								Мы&nbsp;постарались не&nbsp;перегружать визуальный стиль
								и&nbsp;сделали его&nbsp;достаточно универсальным. Дизайн
								подходит для&nbsp;разных типов встреч&nbsp;— от&nbsp;тусовочных
								мероприятий до&nbsp;профессионального нетворкинга.
							</div>
						</div>
					</div>
				</div>
				<img
					src={chinchinpic}
					alt="Экран профиля пользователя в приложении GoChinChin"
					className="about__widepic"
				/>
			</div>

			<div className="feature__wrapper equi__colored">
				<div className="container">
					<div className="containersm">
						<div className="about__title">
							<h2 className="about__titlerow">
								Функционал приложения — &nbsp;от создания встреч до удобного
								поиска событий
							</h2>
						</div>

						<div className="abouts">
							<h3 className="aboutstitle">
								Создание встреч и роли пользователей
							</h3>
							<div className="about__hatinfo">
								GoChinChin позволяет пользователям легко создавать встречи
								и&nbsp;участвовать в&nbsp;них. Для&nbsp;этого предусмотрены
								два&nbsp;сценария использования: администратор встречи
								и&nbsp;участник.
								<div className="br" />
								Для&nbsp;администраторов мы&nbsp;разработали простую
								и&nbsp;понятную форму создания встречи. Нужно лишь заполнить
								поля с&nbsp;датой, местом, тематикой, возрастом участников
								и&nbsp;другими критериями. После&nbsp;заполнения информация
								превращается в&nbsp;карточку встречи, доступную для&nbsp;всех
								пользователей.
								<div className="br" />
								Пользователи могут подавать заявки на&nbsp;участие
								в&nbsp;мероприятии, а&nbsp;организатор имеет возможность
								их&nbsp;одобрить или&nbsp;отклонить.
							</div>
						</div>

						<div className="abouts">
							<h3 className="aboutstitle">Чаты для участников встреч</h3>
							<div className="about__hatinfo">
								Чтобы&nbsp;создать дружелюбную атмосферу, мы&nbsp;добавили чаты
								для&nbsp;участников встреч. Чаты привязаны к&nbsp;конкретным
								встречам, чтобы&nbsp;пользователи не&nbsp;путались
								в&nbsp;переписках и&nbsp;могли легко находить нужные обсуждения.
								<div className="br" />
								Чат&nbsp;становится доступным после&nbsp;одобрения заявки.
								Участники могут познакомиться заранее, что&nbsp;помогает сделать
								атмосферу встречи более расслабленной
							</div>
						</div>
					</div>

					<img
						src={chinchinpic1}
						alt="Чат участников встречи в приложении GoChinChin"
						className="about__widepic"
					/>

					<div className="containersm">
						<div className="abouts">
							<h3 className="aboutstitle">Поиск встреч и&nbsp;мероприятий</h3>
							<div className="about__hatinfo">
								<div>
									Мы&nbsp;уделили особое внимание удобству поиска встреч
									в&nbsp;приложении. Пользователи могут находить мероприятия
									разными способами в&nbsp;зависимости от&nbsp;своих целей.
								</div>
								<div className="numlist">
									<div className="numlistUnit">
										<div className="numlistNum">1.</div>
										<div>
											Поиск по&nbsp;карте. Можно выбрать встречу на&nbsp;карте,
											где&nbsp;отмечены места проведения мероприятий.
										</div>
									</div>

									<div className="numlistUnit">
										<div className="numlistNum">2.</div>
										<div>
											Стандартный поиск по&nbsp;названию. Простой способ найти
											встречу по&nbsp;конкретному названию.
										</div>
									</div>

									<div className="numlistUnit">
										<div className="numlistNum">3.</div>
										<div>
											Удобный поиск по&nbsp;темам и&nbsp;интересам
											с&nbsp;использованием хэштегов. Можно ввести свой хэштег
											или&nbsp;выбрать из&nbsp;популярных вариантов.
										</div>
									</div>

									<div className="numlistUnit">
										<div className="numlistNum">4.</div>
										<div>
											Фильтры для&nbsp;поиска. Мероприятия можно искать
											по&nbsp;различным критериям: дате, времени, возрасту,
											языку, гендеру и&nbsp;другим параметрам. Для&nbsp;удобства
											добавлены популярные быстрые фильтры, например, «Сегодня»,
											чтобы&nbsp;быстро находить актуальные встречи.
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className="abouts">
							<h3 className="aboutstitle">
								Простой и&nbsp;понятный процесс регистрации
							</h3>
							<div className="about__hatinfo">
								Мы&nbsp;сделали процесс регистрации и&nbsp;создания профиля
								максимально простым. Большинство полей представлены в&nbsp;виде
								выпадающих списков, чтобы&nbsp;пользователи не&nbsp;тратили
								время на&nbsp;ввод данных и&nbsp;не&nbsp;сомневались
								в&nbsp;правильности заполнения. Это&nbsp;снижает количество
								отказов на&nbsp;этапе регистрации и&nbsp;увеличивает число
								пользователей, успешно начинающих пользоваться приложением.
							</div>
						</div>
					</div>
					<img
						src={mapped}
						alt="Навигационное меню приложения GoChinChin с быстрыми фильтрами"
						className="about__widepic"
					/>
				</div>
			</div>

			<div className="feature__wrapper">
				<div className="container">
					<div className="containersm">
						<div className="about__title">
							<h2 className="about__titlerow">
								Интересные детали и&nbsp;фишки, которые делают GoChinChin
								удобным и&nbsp;функциональным
							</h2>
						</div>

						<div className="abouts">
							<h3 className="aboutstitle">Рейтинги и&nbsp;отзывы участников</h3>
							<div className="about__hatinfo">
								После&nbsp;встречи участники могут выставлять рейтинг друг
								другу. Пользователи могут видеть, насколько надёжным
								и&nbsp;приятным в&nbsp;общении является другой участник
								или&nbsp;организатор встречи. Рейтинг мы&nbsp;сделали всем
								знакомым и&nbsp;понятным способом: выставление звёзд
								от&nbsp;1&nbsp;до&nbsp;5.&nbsp;
								<div className="br" />
								Также&nbsp;можно писать отзывы к&nbsp;встречам.
								Так&nbsp;организаторы могут понять, что&nbsp;улучшить
								в&nbsp;своих мероприятиях&nbsp;— например, изменить место, время
								или&nbsp;формат встречи.
							</div>
						</div>

						<div className="abouts">
							<h3 className="aboutstitle">
								Удобные иконки для&nbsp;уведомлений
							</h3>
							<div className="about__hatinfo">
								На&nbsp;странице уведомлений мы&nbsp;использовали разные иконки
								для&nbsp;каждого типа сообщений. Это&nbsp;помогает пользователям
								быстро воспринимать информацию и&nbsp;расставлять приоритеты,
								так&nbsp;как&nbsp;визуальные элементы считываются быстрее,
								чем&nbsp;текст.
							</div>
						</div>

						<div className="abouts">
							<h3 className="aboutstitle">Быстрые кнопки для&nbsp;действий</h3>
							<div className="about__hatinfo">
								В&nbsp;уведомлениях и&nbsp;модальных окнах, где&nbsp;нужны
								дальнейшие действия, мы&nbsp;добавили быстрые кнопки.
								Это&nbsp;экономит время и&nbsp;позволяет сразу переходить
								на&nbsp;нужные экраны. Благодаря этому пользователи быстрее
								выполняют задачи, остаются активными и&nbsp;дольше пользуются
								приложением.
							</div>
						</div>
					</div>
					<img
						src={rating}
						alt="Отзывы участников о мероприятии в приложении GoChinChin"
						className="about__widepic about__chinchinmobile"
					/>
				</div>
			</div>

			<div className="feature__wrapper equi__colored">
				<div className="container">
					<div className="containersm">
						<div className="about__title">
							<div>
								<h2 className="about__titlerow">
									Компактная и&nbsp;гибкая дизайн система
									для&nbsp;масштабирования
								</h2>
								<div className="about__hatinfo hatinfo__hatfix">
									У&nbsp;нас&nbsp;получилась небольшая, но&nbsp;гибкая дизайн
									система, которую легко поддерживать и&nbsp;масштабировать.
									В&nbsp;ней&nbsp;только необходимые компоненты,
									что&nbsp;позволяет быстро вносить изменения
									и&nbsp;адаптировать дизайн под&nbsp;новые задачи
									и&nbsp;сценарии.
								</div>
							</div>
						</div>
					</div>

					<img
						src={system}
						alt="Яркие элементы интерфейса GoChinChin для удобной навигации"
						className="about__widepic"
					/>
				</div>
			</div>

			<div className="feature__wrapper">
				<div className="container">
					<div className="containersm">
						<div className="about__title">
							<h2 className="about__titlerow">
								От&nbsp;ТЗ&nbsp;до&nbsp;результата:
								как&nbsp;мы&nbsp;адаптировали проект в&nbsp;поисках лучшего
								решения
							</h2>
						</div>

						<div className="researchs">
							<h3 className="researchs__subtitle">
								Сроки проекта, правки и&nbsp;доработки
							</h3>
							<div>
								Проект длился 3&nbsp;месяца, включая все&nbsp;правки
								и&nbsp;доработки. В&nbsp;процессе работы
								мы&nbsp;по&nbsp;согласованию с&nbsp;заказчиком отходили
								от&nbsp;изначального ТЗ, добавляя новые экраны и&nbsp;функционал
								для&nbsp;создания полноценного и&nbsp;удобного приложения.
								Например, была добавлена функция модерирования чатов
								и&nbsp;участников встречи для&nbsp;организаторов.
							</div>
						</div>

						<div className="researchs">
							<h3 className="researchs__subtitle">Поиск визуального решения</h3>
							<div>
								На&nbsp;этапе концепции мы&nbsp;столкнулись
								с&nbsp;вызовом&nbsp;— визуальный дизайн, по&nbsp;представлению
								и&nbsp;задумке заказчика, должен был&nbsp;быть нестандартным.
								Но&nbsp;мы&nbsp;справились. Благодаря тесному сотрудничеству
								и&nbsp;серии обсуждений мы&nbsp;нашли стиль, который полностью
								соответствовал ожиданиям и&nbsp;сделал приложение более
								привлекательным для&nbsp;пользователей.
							</div>
						</div>

						<div className="researchs">
							<h3 className="researchs__subtitle">
								Локализация для&nbsp;расширения аудитории
							</h3>
							<div>
								После&nbsp;успешного завершения проекта мы&nbsp;перевели
								приложение на&nbsp;русский язык, чтобы&nbsp;расширить
								его&nbsp;аудиторию и&nbsp;сделать продукт доступным
								для&nbsp;новых пользователей.
							</div>
						</div>
					</div>
				</div>
				<img
					src={screenshot}
					alt="Компактная и гибкая дизайн система приложения GoChinChin"
					className="about__widepic"
				/>

				<div className="container">
					<button
						className="action__button"
						onClick={() => {
							navigate(`?modal`);
						}}
					>
						Обсудить проект
					</button>
				</div>
			</div>

			<div className="footerwrapper">
				<div className="container">
					<Footer backgroundColor="transparent" />
				</div>
			</div>

			<ContactUsModal />
		</div>
	);
}

export default ChinChinPage;
